import { Shadows } from '@mui/material';

declare module '@mui/material/styles' {
	interface Palette {
		appBackground: string;
	}

	interface PaletteOptions {
		appBackground?: string;
	}
}

export const themeBase = {
	shadows: Array(25).fill('none') as Shadows
};
